import { contextFactory } from '../../hooks/context-factory';
import { MultiStepControl } from './multi-step.hooks';

export const [MultiStepContext, useMultiStepContext] = contextFactory<MultiStepControl>();
